import React from 'react';

export default function ReturnPolicy() {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8">Return Policy</h1>
      <div className="prose max-w-none">
        <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">1. Return Period</h2>
        <p>We accept returns within 30 days of purchase for unopened products in their original packaging.</p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">2. Return Conditions</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>Product must be unopened and in original packaging</li>
          <li>All safety seals must be intact</li>
          <li>Original proof of purchase required</li>
          <li>Return shipping costs are the responsibility of the customer</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">3. Refund Process</h2>
        <p>Once we receive and inspect your return:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>We will notify you of the approval or rejection of your refund</li>
          <li>If approved, refund will be processed within 5-7 business days</li>
          <li>Credit will be automatically applied to your original payment method</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">4. Damaged Items</h2>
        <p>If you receive a damaged product:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>Contact us within 48 hours of receipt</li>
          <li>Provide photos of the damage</li>
          <li>We will arrange for return shipping at our expense</li>
          <li>A replacement will be shipped once we receive the damaged item</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">5. Non-Returnable Items</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>Opened or used products</li>
          <li>Products without original packaging</li>
          <li>Items damaged due to improper use</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">6. Contact Information</h2>
        <p>For return-related inquiries, please contact us at support@marinefuelboost.com</p>

        <div className="bg-blue-50 p-4 rounded-lg mt-8">
          <h3 className="text-xl font-semibold mb-2">Satisfaction Guarantee</h3>
          <p>We stand behind our products 100%. If you're not completely satisfied with your purchase, please contact us and we'll make it right.</p>
        </div>
      </div>
    </div>
  );
} 